import { render, staticRenderFns } from "./SocialMedias.vue?vue&type=template&id=16811a6a&scoped=true&"
import script from "./SocialMedias.vue?vue&type=script&lang=js&"
export * from "./SocialMedias.vue?vue&type=script&lang=js&"
import style0 from "./SocialMedias.vue?vue&type=style&index=0&id=16811a6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16811a6a",
  null
  
)

export default component.exports